export default function($injector) {
	let $timeout = $injector.get('$timeout');

	let directive = {
		restrict: 'E',
		template: '<div class="loading-indicator__container" ng-show="isLoading"><div class="loading-indicator"><md-progress-circular md-mode="indeterminate" md-diameter="96"></md-progress-circular></div></div>',
		link: function(scope, elem, attrs) {
			scope.isLoading = false;

			scope.$on('wco-loading-indicator:show', function(attrs){
				scope.isLoading = true;
			});

			scope.$on('wco-loading-indicator:hide', function(attrs){
				scope.isLoading = false;
			});
		}
	}

	return directive;
}
